/**
 * AI usage feature — re-exports the generated backend DTOs and the few
 * UI-only union types the page consumes.
 *
 * NEVER re-declare backend fields here. If a new column is needed,
 * either extend the OpenAPI schema and regenerate, or compose via a
 * UI-only intersection in `@/models`.
 */
export type {
  AiUsageEndpoint,
  AiUsageModel,
  AiUsageMonth,
  AiUsageReport,
} from '@/api/types';

export type MonthsOption = 3 | 6 | 12;

export const MONTHS_OPTIONS: readonly MonthsOption[] = [3, 6, 12] as const;
export const DEFAULT_MONTHS: MonthsOption = 6;
